import { Box, Button } from "@material-ui/core";
import React, { useRef, useState } from "react";
import GetAppIcon from "@material-ui/icons/GetApp";
import PublishIcon from "@material-ui/icons/Publish";
import ImportDialog from "./import-dialog";
import { exportFileHandler } from "../utils/NetworkHanlder";

export default function ImportExportFileButtons({ updateData, filters }) {
  const fileInputRef = useRef(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [fileData, setFileData] = useState(null);
  const [importOptions, setImportOptions] = useState({
    keepDeviceCalibrationsDoneAfterExport: true,
    revertDeviceCalibrationsDeletedAfterExport: false,
    keepDeviceCalibrationsModificationsDoneAfterExport: false,
  });
  const handleFileSelect = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        setFileData(file);
        setModalOpen(true);
        console.log(file);
        console.log(modalOpen);
      } catch (error) {
        alert("Wybrany plik jest niepoprawny.");
        console.error("Błąd parsowania JSON:", error);
      }
    };
    reader.readAsText(file);
  };

  const exportButtonHandler = async () => {
    const { data } = await exportFileHandler();
    const jsonString = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonString], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hour = String(now.getHours()).padStart(2, "0");
    const minute = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    const date = `${year}-${month}-${day}-time-${hour}-${minute}-${seconds}`;
    const fileName = `calibrations-export-${date}.json`;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  return (
    <Box>
      <Button
        variant="outlined"
        color="primary"
        startIcon={<GetAppIcon />}
        style={{ marginRight: "10px" }}
        onClick={() => fileInputRef.current.click()}
      >
        Importuj
      </Button>
      <input
        type="file"
        accept=".json"
        style={{ display: "none" }}
        ref={fileInputRef}
        onClick={(event) => {
          event.target.value = null;
        }}
        onChange={(event) => {
          handleFileSelect(event);
        }}
      />
      <Button
        variant="contained"
        color="primary"
        startIcon={<PublishIcon />}
        onClick={() => exportButtonHandler()}
      >
        Eksportuj
      </Button>
      <ImportDialog
        setModalOpen={setModalOpen}
        modalOpen={modalOpen}
        importOptions={importOptions}
        setImportOptions={setImportOptions}
        fileData={fileData}
        setFileData={setFileData}
        updateData={updateData}
        filters={filters}
      />
    </Box>
  );
}
